<app-banner></app-banner>

<div id="tiny" class="my-5">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Tiny Tots</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our Tiny Tots page! We believe that early childhood education is the foundation for lifelong learning and success. That's why we offer a variety of age-appropriate activities for our youngest learners. </p>
                    <p class="inner-lead">We believe that learning should be fun and engaging, and our Tiny Tots program is the perfect place for your child to explore, discover and grow.

                    </p>  
                    <p class="inner-lead font-weight-bold">Instructions for parents:-
                    </p>
                    <ul>
                      <li>
                        <p class="inner-lead">Please send your ward in proper uniform daily.</p>
                      </li>
                      <li>
                        <p class="inner-lead">Please send handkerchief daily.
                        </p>
                      </li>
                      <li>
                        <p class="inner-lead">Send some fruit in tiffin.
                        </p>
                      </li>
                      <li>
                        <p class="inner-lead">Wrap the chapati with foilpaper and send vegetables also. Don’t send pickle.
                        </p>
                      </li>
                      <li>
                        <p class="inner-lead">Send paper napkin in the tiffin daily.
                        </p>
                      </li>
                      <li>
                        <p class="inner-lead">Cover all the notebooks and books.
                        </p>
                      </li>
                      <li>
                        <p class="inner-lead">Please send extra pair of dress in the bag daily.
                        </p>
                      </li>
                      <li>
                        <p class="inner-lead">Sig after reading the notice.
                        </p>
                      </li>
                      <li>
                        <p class="inner-lead">Please deposit 2 Pencil boxes, 1 Eraser box, 6 sharpeners,1 Crayons box in the beginning of the session. (April- May)
                        </p>
                      </li>
                      <li>
                        <p class="inner-lead">Please attend every P.T.M.
                        </p>
                      </li>
                      <li>
                        <p class="inner-lead">Check your ward’s diary daily.
                        </p>
                      </li>
                   
                    </ul>
                    <div class="row">
                      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-4 text-center" *ngFor="let img of imgUrl;">
                          <a href="{{img}}" data-lightbox="Tiny Tots"><img [src]="img" alt="Tiny Tots" class="img-fluid rounded"></a>
                      </div>
                    </div>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>